export const getAudioContext = () => {
  const dataContext = new (window.AudioContext || window.webkitAudioContext)();
  const dataAnalyser = dataContext.createAnalyser();

  const createParamsArray = params =>
    params.map(param => ({
      id: param,
      description: dataContext[param] !== undefined ? dataContext[param] : "-",
    }));

  const audioContextParams = ["sampleRate", "state"];
  const audioContext = createParamsArray(audioContextParams);

  const analyserParams = [
    "channelCount",
    "channelCountMode",
    "channelInterpretation",
    "fftSize",
    "frequencyBinCount",
    "maxDecibels",
    "minDecibels",
    "numberOfInputs",
    "numberOfOutputs",
    "smoothingTimeConstant",
  ];

  const createAnalyserParamsArray = params =>
    params.map(param => ({
      id: param,
      description:
        dataAnalyser[param] !== undefined ? dataAnalyser[param] : "-",
    }));

  const analyser = createAnalyserParamsArray(analyserParams);

  return { audioContext, analyser };
};
